import {ListItem} from "../common/list-view/list-item";


/**
 * Classe représentant un montant
 */
export class Montant implements ListItem {
    idPrestation: number;
    dateApplication: Date;
    taux: number;

    constructor(dto?: any) {
        if (dto) {
            Object.assign(this,dto);
        }
    }

    getKey(): number {
        return this.idPrestation;
    }
}